import React from "react"
import { Flex, SimpleGrid } from "@chakra-ui/react"

import { LockType } from "../../utils/lock-picking/types"
import MatchupItem from "./matchup-item"

const LockTable: React.FC<{ locks: LockType[]; columns?: number }> = ({
    locks,
    columns,
}) => {
    return (
        <Flex align="center" flexDir="column" w="100%">
            <SimpleGrid
                columns={{ base: 1, md: columns || 2 }}
                maxW={"820px"}
                w="100%"
                justifyItems="center"
            >
                {locks.map((lock, index) => (
                    <MatchupItem matchup={lock} key={index} />
                ))}
            </SimpleGrid>
        </Flex>
    )
}

export default LockTable
